document.addEventListener("DOMContentLoaded", () => {
  /* =========================================================
     SHARED AUDIO PLAYER
  ========================================================= */

  const playButtons = document.querySelectorAll(
    "[data-dt-hero-play]"
  );

  if (!window.DistantTravelerPlayer) {
    window.DistantTravelerPlayer = {
      audio: new Audio(),
      currentButton: null,
      currentTrack: null
    };

    window.DistantTravelerPlayer.audio.preload = "metadata";
  }

  const player = window.DistantTravelerPlayer;


  /* =========================================================
     HERO PLAY BUTTON
  ========================================================= */

  playButtons.forEach((button) => {
    const label = button.querySelector(
      "[data-dt-hero-play-label]"
    );

    button.addEventListener("click", async () => {
      const audioUrl = button.dataset.audio;

      if (!audioUrl) {
        console.warn(
          "Distant Traveler: add the Under My Skin MP3 URL in the Distant Top section."
        );
        return;
      }

      const sameSong =
        player.currentButton === button &&
        player.audio.src;


      /* PAUSE CURRENT SONG */

      if (sameSong && !player.audio.paused) {
        player.audio.pause();
        return;
      }


      /* RESUME CURRENT SONG */

      if (sameSong && player.audio.paused) {
        try {
          await player.audio.play();
        } catch (error) {
          console.warn(
            "Audio could not play:",
            error
          );
        }

        return;
      }


      /* LOAD NEW SONG */

      if (
        player.currentButton &&
        player.currentButton !== button
      ) {
        const previousLabel =
          player.currentButton.querySelector(
            "[data-dt-hero-play-label]"
          );

        player.currentButton.classList.remove(
          "is-playing"
        );

        if (previousLabel) {
          previousLabel.textContent = "PLAY NOW";
        }
      }


      player.currentButton = button;

      player.currentTrack = {
        title:
          button.dataset.title ||
          "UNDER MY SKIN",

        audio: audioUrl
      };

      player.audio.src = audioUrl;
      player.audio.load();


      try {
        await player.audio.play();

        window.dispatchEvent(
          new CustomEvent(
            "distant:trackchange",
            {
              detail: player.currentTrack
            }
          )
        );

      } catch (error) {
        console.warn(
          "Audio could not play:",
          error
        );
      }
    });


    /* PLAY STATE */

    player.audio.addEventListener(
      "play",
      () => {
        if (
          player.currentButton !== button
        ) {
          return;
        }

        button.classList.add(
          "is-playing"
        );

        if (label) {
          label.textContent = "PAUSE";
        }

        window.dispatchEvent(
          new CustomEvent(
            "distant:play"
          )
        );
      }
    );


    /* PAUSE STATE */

    player.audio.addEventListener(
      "pause",
      () => {
        if (
          player.currentButton !== button
        ) {
          return;
        }

        button.classList.remove(
          "is-playing"
        );

        if (label) {
          label.textContent = "PLAY NOW";
        }

        window.dispatchEvent(
          new CustomEvent(
            "distant:pause"
          )
        );
      }
    );


    /* SONG FINISHED */

    player.audio.addEventListener(
      "ended",
      () => {
        if (
          player.currentButton !== button
        ) {
          return;
        }

        button.classList.remove(
          "is-playing"
        );

        if (label) {
          label.textContent = "PLAY NOW";
        }

        window.dispatchEvent(
          new CustomEvent(
            "distant:ended"
          )
        );
      }
    );
  });



  /* =========================================================
     YOUTUBE VIDEO MODAL
  ========================================================= */

  const videoButtons =
    document.querySelectorAll(
      "[data-dt-video-open]"
    );

  const videoModal =
    document.querySelector(
      "[data-dt-video-modal]"
    );

  const videoIframe =
    document.querySelector(
      "[data-dt-video-iframe]"
    );

  const videoCloseButtons =
    document.querySelectorAll(
      "[data-dt-video-close]"
    );


  /* GET YOUTUBE VIDEO ID */

  function getYouTubeId(url) {
    if (!url) return null;

    try {
      const parsed =
        new URL(url);


      /* youtu.be/VIDEOID */

      if (
        parsed.hostname.includes(
          "youtu.be"
        )
      ) {
        return parsed.pathname
          .replace("/", "")
          .split("?")[0];
      }


      /* youtube.com */

      if (
        parsed.hostname.includes(
          "youtube.com"
        )
      ) {

        /* Shorts */

        if (
          parsed.pathname.startsWith(
            "/shorts/"
          )
        ) {
          return parsed.pathname
            .split("/shorts/")[1]
            .split("/")[0];
        }


        /* Embed */

        if (
          parsed.pathname.startsWith(
            "/embed/"
          )
        ) {
          return parsed.pathname
            .split("/embed/")[1]
            .split("/")[0];
        }


        /* Normal YouTube URL */

        return parsed.searchParams.get(
          "v"
        );
      }

    } catch (error) {
      console.warn(
        "Invalid YouTube URL:",
        error
      );
    }

    return null;
  }


  /* OPEN VIDEO */

  videoButtons.forEach((button) => {
    button.addEventListener(
      "click",
      () => {
        const videoUrl =
          button.dataset.videoUrl;

        const videoId =
          getYouTubeId(
            videoUrl
          );

        if (
          !videoId ||
          !videoModal ||
          !videoIframe
        ) {
          console.warn(
            "Distant Traveler: valid YouTube URL not found."
          );

          return;
        }


        /*
         * Pause music when opening
         * a music video.
         */

        if (
          player.audio &&
          !player.audio.paused
        ) {
          player.audio.pause();
        }


        videoIframe.src =
          `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`;


        videoModal.classList.add(
          "is-open"
        );

        videoModal.setAttribute(
          "aria-hidden",
          "false"
        );

        document.body.classList.add(
          "dt-video-open"
        );
      }
    );
  });



  /* =========================================================
     CLOSE VIDEO
  ========================================================= */

  function closeVideo() {
    if (
      !videoModal ||
      !videoIframe
    ) {
      return;
    }

    videoModal.classList.remove(
      "is-open"
    );

    videoModal.setAttribute(
      "aria-hidden",
      "true"
    );


    /*
     * Clearing the iframe URL
     * completely stops YouTube.
     */

    videoIframe.src = "";


    document.body.classList.remove(
      "dt-video-open"
    );
  }


  videoCloseButtons.forEach(
    (button) => {
      button.addEventListener(
        "click",
        closeVideo
      );
    }
  );


  /* ESC KEY CLOSES VIDEO */

  document.addEventListener(
    "keydown",
    (event) => {
      if (
        event.key === "Escape" &&
        videoModal?.classList.contains(
          "is-open"
        )
      ) {
        closeVideo();
      }
    }
  );
});